// 面导出该模块state、actions、mutations
import actions from './actions'
import AreaIndustryUser from './metaData/areaIndustryUser'
export default {
  state: AreaIndustryUser,
  actions
}
